const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://worm-counter-rnix.onrender.com';

export const analyzeVideo = async (videoFile) => {
    const formData = new FormData();
    formData.append('video', videoFile);

    const response = await fetch(`${API_BASE_URL}/api/analyze`, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || `Analysis failed: ${response.statusText}`);
    }

    const data = await response.json();

    // Transform backend response to match frontend format
    return {
        totalWorms: data.data?.totalWorms || 0,
        maxInFrame: data.data?.maxInFrame || 0,
        avgPerFrame: data.data?.avgPerFrame || 0,
        framesProcessed: data.data?.framesProcessed || 0,
        processingTime: data.data?.processingTime || 'Calculating...',
        confidence: data.data?.confidence || 'High',
        videoId: data.data?.videoId // Add this for download functionality
    };
};

export const downloadVideo = async (videoId) => {
    const response = await fetch(`${API_BASE_URL}/api/download/${videoId}`);

    if (!response.ok) {
        throw new Error(`Download failed: ${response.statusText}`);
    }

    const blob = await response.blob();
    return blob;
};

// For demo purposes - remove when using real API
// export const analyzeVideoDemo = async (videoFile) => {
//     // Simulate API call delay
//     await new Promise(resolve => setTimeout(resolve, 3000));

//     // Mock response
//     return {
//         totalWorms: Math.floor(Math.random() * 30) + 15,
//         maxInFrame: Math.floor(Math.random() * 25) + 10,
//         avgPerFrame: (Math.random() * 15 + 8).toFixed(1),
//         framesProcessed: 302,
//         processingTime: '12.3s',
//         confidence: '87%',
//         videoId: 'demo_video_' + Date.now() + '.mp4'
//     };
// };